export const GLOBAL_ZOOM = 2;
/** 그리다보드 뷰의 확대 최소 값 */
export const PDFVIEW_ZOOM_MIN = 0.25;
/** 그리다보드 뷰의 확대 최대 값 */
export const PDFVIEW_ZOOM_MAX = 3.0;
// export const PDFVIEW_ZOOM_MAX = 6.0;
/** PDF 뷰어의 최대 픽셀 값, byte로는 아래 값*4, 64Mpixel = 256MB */
export const MAX_RENDERER_PIXELS = 4 * 1024 * 1024;
export const MAX_PDF_RENDERER_PIXELS = 1.5 * 1024 * 1024;
//# sourceMappingURL=RendererConstants.js.map